const classNames = {
  INITIALIZED: 'sign-in__master-control--initialized',
  PROGRESS_CLOSED: 'mdc-linear-progress--closed',
};

const selectors = {
  PROGRESS: '.mdc-linear-progress',
};

export class MasterControl {
  get disabled() {
    return this.$element.disabled;
  }
  set disabled(value) {
    this.$element.disabled = value;
  }

  get progress() {
    return this.$progress.classList.contains(classNames.PROGRESS_CLOSED);
  }
  set progress(value) {
    if (value) {
      this.$progress.classList.remove(classNames.PROGRESS_CLOSED);
      this.$progress.setAttribute('aria-hidden', 'false');
    } else {
      this.$progress.classList.add(classNames.PROGRESS_CLOSED);
      this.$progress.setAttribute('aria-hidden', 'true');
    }
  }

  private readonly $element: HTMLFieldSetElement;
  private readonly $progress: HTMLElement;

  constructor(selector: string) {
    this.$element = document.querySelector(selector) as HTMLFieldSetElement;

    if (this.$element == null) {
      throw new Error('Master control element not found.');
    }

    this.$progress = this.$element.querySelector(selectors.PROGRESS) as HTMLElement;

    if (this.$progress == null) {
      throw new Error('Progress element not found in master control.');
    }

    this.init();
  }

  init() {
    this.progress = false;
    this.$element.classList.add(classNames.INITIALIZED);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/ui/master-control.ts